module.exports = __webpack_public_path__ + "img/emptyClose.4c6d7d9a.svg";